import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DescricaoComponent } from './descricao.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

@NgModule({
  declarations: [
    DescricaoComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    LocalizeRouterModule
  ],
  exports: [
    DescricaoComponent
  ]
})

export class DescricaoModule { }
